import { generateLabelWithClass } from '../../Label';
import styles from './ExpansionHeader.module.scss';

export default generateLabelWithClass(styles.root);
